import CartButtonLoyaltyEnabled from './CartButtonLoyaltyEnabled';

export default CartButtonLoyaltyEnabled;
